module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/3@2x_2e920a677eed43d9038cef7e0e657d2a.png";